import { useEffect } from 'react';
import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom';
import { useI18n } from '../i18n';
import { DEFAULT_LOCALE, isLocale, stripLocale, withLocale } from '../lib/localePath';

/** Sync i18n with URL locale and render nested routes */
export function LocaleRoute() {
  const { locale: param } = useParams();
  const { locale, setLocale } = useI18n();

  useEffect(() => {
    if (isLocale(param) && param !== locale) {
      setLocale(param);
    }
  }, [param, locale, setLocale]);

  if (!isLocale(param)) {
    return <Navigate to={withLocale(DEFAULT_LOCALE, '/')} replace />;
  }

  return <Outlet />;
}

/** Redirect bare paths (no locale) to FR default — stable for crawlers */
export function LegacyLocaleRedirect() {
  const { pathname, search, hash } = useLocation();
  const bare = stripLocale(pathname);
  return (
    <Navigate to={`${withLocale(DEFAULT_LOCALE, bare)}${search}${hash}`} replace />
  );
}
